<template>
  <div style="">
    <v-row>
      <v-col md="12" class="pt-2">
        <v-combobox
          v-model="selectedAttendees"
          ref="combobox"
          class="searchComboBox"
          id="searchComboBox"
          :label="`${$t('agenda.lblAttendees')} *`"
          color="#CCCCCC"
          dense
          chips
          clearable
          multiple
          filled
          append-icon=""
          @focus="activeDropDown = true"
          hide-details
          @input="onUpdate"
          v-on:keyup.native="searchData($event), activeDropDown == false ? activeDropDown = true : ''"
          v-on:keyup.enter.native="activeDropDown = false"
        >
          <template v-slot:selection="data">
            <v-chip
              small
              :key="JSON.stringify(data.item)"
              v-bind="data.attrs"
              :input-value="data.selected"
              :disabled="data.disabled"
              @click:close="data.parent.selectItem(data.item)"
              color="secondary darken-3"
              class="ma-1 pl-2"
            >
              <v-avatar v-if="data.item.email" left>
                <v-img
                  v-if="data.item.profilePhoto"
                  contain
                  :src="data.item.profilePhoto"
                ></v-img>
                <v-img
                  v-else
                  contain
                  src="@/assets/images/NoPhotoIcon.png"
                ></v-img>
              </v-avatar>
              <span v-if="data.item.firstName">
                {{ data.item.firstName + " " + data.item.lastName }} 
                <!-- <small>({{ data.item.email }})</small> -->
                </span>
              <span v-else> {{ data.item.email }}</span>
            </v-chip>
          </template>
        </v-combobox>
        <div style="position: relative;">
        <v-card
          class="user-combo-selection"
          v-if="activeDropDown"
          elevation="3"
          id="scroll-target"
          v-click-outside="{
            handler: onClickOutside,
            closeConditional: onCloseConditional
          }"
          >
          <v-card-text v-scroll:#scroll-target="onScroll" style="max-height: 300px" class="overflow-y-auto ma-0 pa-0">
              <v-list color="#FFF" class="combo-list" v-if="filteredData.length > 0">
                <template v-for="item in filteredData">
                  <v-list-item v-if="item.contactEmailIds && item.contactEmailIds.length <= 1" :key="`email-${item.email}-${uniqueKey()}`" @click.prevent="selectEmail(item.id, item.email)" :class="[itemSelected(item.email) ? 'selected-removed' : '']">
                    <v-list-item-avatar class="mt-0 mb-0 mr-2" size="40">
                        <v-img v-if="item.profilePhoto" contain :src="item.profilePhoto"></v-img>
                        <v-img v-else contain src="@/assets/images/NoPhotoIcon.png"></v-img>
                    </v-list-item-avatar>
                    
                    <v-list-item-content>
                      <v-list-item-title>
                        <!-- {{ item.contactEmailIds && item.contactEmailIds.length ? item.contactEmailIds.length : 0 }} /- -->
                        <label>
                          <span v-if="item.firstName">
                            {{ item.firstName + " " + item.lastName }}
                          </span>
                          <span v-else>{{ item.email }}</span>
                        </label>
                        
                      </v-list-item-title>
                      <v-list-item-subtitle v-if="item.firstName">
                        <label>
                          {{ item.email }}
                        </label>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-avatar class="mt-0 mb-0 mr-2" size="40" v-if="itemSelected(item.email)">
                       <v-icon color="green" left >mdi-check </v-icon>
                    </v-list-item-avatar>
                    <v-list-item-action style="flex-direction: inherit">
                        <v-btn
                        outlined
                        x-small
                          color="primaryDark"
                          class="mr-2"
                          v-if="item.is_listed_in_people === true"
                        >
                          {{ $t('admin.lblListedInPeople') }}
                        </v-btn>
                        <v-btn
                          outlined
                          x-small
                          color="primaryDark"
                          v-if="item.is_registered_user === true"
                        >
                          {{ $t('admin.lblRegistered') }}
                        </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-group
                        v-else
                        :key="`group_${item.email}-${uniqueKey()}`"
                        v-model="item.active"
                        no-action
                        class="bg-divider" 
                        :class="[itemSelectedGroup(item.id) ? 'selected-removed' : '']"
                      >
                     
                      <template v-slot:activator>
                      <v-list-item-avatar class="mt-0 mb-0 mr-2" size="40">
                          <v-img v-if="item.profilePhoto" contain :src="item.profilePhoto"></v-img>
                          <v-img v-else contain src="@/assets/images/NoPhotoIcon.png"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          <!-- {{ item.contactEmailIds && item.contactEmailIds.length ? item.contactEmailIds.length : 0 }} /- group -->
                          <label>
                            <span v-if="item.firstName">
                              {{ item.firstName + " " + item.lastName }}
                            </span>
                            <span v-else>{{ item.email }}</span>
                          </label>
                        </v-list-item-title>
                        <v-list-item-subtitle v-if="item.firstName">
                          <label>
                            {{ item.email }}
                          </label>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-avatar class="mt-0 mb-0 mr-2" size="40" v-if="itemSelectedGroup(item.id)">
                       <v-icon color="green" left >mdi-check </v-icon>
                    </v-list-item-avatar>
                      <v-list-item-action style="flex-direction: inherit">
                        <v-btn
                        outlined
                        x-small
                          color="primaryDark"
                          class="mr-2"
                          v-if="item.is_listed_in_people === true"
                        >
                          {{ $t('admin.lblListedInPeople') }}
                        </v-btn>
                        <v-btn
                          outlined
                          x-small
                          color="primaryDark"
                          v-if="item.is_registered_user === true"
                        >
                          {{ $t('admin.lblRegistered') }}
                        </v-btn>
                      </v-list-item-action>
                      </template>
                      <template>
                      <v-divider></v-divider>
                      <v-subheader v-if="item.contactEmailIds && item.contactEmailIds.length > 0" class="text-subtitle-2 mt-2 mb-0 pt-0 pb-0" color="black" style="height: 25px">{{ $t('admin.lblContactEmailList') }}:</v-subheader>
                      <v-list-item v-for="contactEmail in item.contactEmailIds" :key="`email-${contactEmail}-${uniqueKey()}`" @click.prevent="selectEmail(item.id, contactEmail)" :class="[itemSelected(contactEmail) ? 'selected-removed' : '']">
                        <v-list-item-avatar class="mt-0 mb-0 mr-2" size="40" v-if="itemSelected(contactEmail)">
                          <v-icon color="green" left>mdi-check </v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <label>
                            <span >{{ contactEmail }}</span>
                          </label>
                        </v-list-item-content>
                        <v-list-item-action style="flex-direction: inherit">
                          <v-btn
                          outlined
                          x-small
                            color="primaryDark"
                            class="mr-2"
                            v-if="item.is_listed_in_people === true && item.email == contactEmail"
                          >
                            {{ $t('admin.lblListedInPeople') }}
                          </v-btn>
                          <v-btn
                            outlined
                            x-small
                            color="primaryDark"
                            v-if="item.is_registered_user === true && item.email == contactEmail"
                          >
                            {{ $t('admin.lblRegistered') }}
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider></v-divider>
                    </template>
                  </v-list-group>
                </template>
               
            </v-list>
            <v-list color="#F4F4F4" v-else>
              <v-list-item>
                No matching records found!!
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
        </div>
      </v-col>
      <v-col md="12" class="mt-0 pt-0">
        <v-list lines="two">
          <template v-for="(item, index) in selectedAttendees">
            <v-list-item :key="`item_${index}_${item.id}`">
              <v-list-item-avatar class="mt-0 mb-0" size="30">
                <v-img
                  v-if="item.profilePhoto"
                  contain
                  :src="item.profilePhoto"
                ></v-img>
                <v-img
                  v-else
                  contain
                  src="@/assets/images/NoPhotoIcon.png"
                ></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <span v-if="item.firstName">
                  {{ item.firstName + " " + item.lastName }}
                </span>
                <span v-else>{{ item.email }}</span>
                <v-list-item-subtitle v-if="item.firstName">
                  {{ item.email }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <a-btn
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      color="primaryDark"
                      width="24"
                      min-width="24"
                      class="mt-4"
                      @click="deleteAttende(item.id)"
                    >
                      <v-icon size="16" color="#fff"> mdi-delete</v-icon>
                    </a-btn>
                  </template>
                  <span>{{ $t("lblDeleteAttendees") }}</span>
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>
            <v-divider :key="`divider_${index}_${item.id}`"></v-divider>
          </template>
        </v-list>
      </v-col>
    </v-row>
    <Loader :loading="Loaderloading" :message="LoaderText"></Loader>
  </div>
</template>
<script>
import Loader from "@/components/Loader.vue";
import { mapActions, mapState } from "vuex";
import { createUUID } from "../../utils/util";
import ABtn from "../../wrapper-component/ABtn.vue";
import _ from "lodash";
import peopleService from "../../api/peopleService";

export default {
  name: "MeetingParticipantListNew",
  components: {
    ABtn,
    Loader,
  },
  data() {
    return {
      activeDropDown: false,
      selectedAttendees: [],
      newAttendeeEmail: [],
      attendeeSearch: "",
      Loaderloading: false,
      page: 1,
      itemsPerPage: 10000,
      offsetTop: 0,
    };
  },
  props: {
    meetingAtteendeelist: Array,
    value: {
      type: Array,
      default: () => [],
    },
  },
  async mounted() {
    this.Loaderloading = true;
    this.meetingAtteendeelist.forEach((atteendee) => {
      this.selectedAttendees.push({
              id: atteendee.id,
              email: atteendee.email,
              firstName: atteendee.firstName,
              lastName: atteendee.lastName,
              profilePhoto: atteendee.profilePhoto,
              title: atteendee.title,
              attendedState: atteendee.attendedState
          })
    })
    this.Loaderloading = false;
  },
  watch: {
    async selectedAttendees(value) {
      if (value) {
        let entry = this.selectedAttendees[this.selectedAttendees.length - 1];
        if (!entry) {
          return;
        }
        if (entry.email) {
          const existingPerson = this.usersWithContactEmails.find(
            (elem) => elem.email == entry.email
          );
          if (!existingPerson) {
            const person = this.addItem(entry.email);
            this.selectedAttendees[this.selectedAttendees.length - 1] = person;
          }
          this.attendeeSearch = "";
        } else {
          if (validateEmail(entry)) {
            const count = this.selectedAttendees.length - 1;
            this.isEmailvalidate = true;
            this.selectedAttendees[count] = this.addItem(entry);
            this.Loaderloading = true
            const existUser = await peopleService.check_email(entry);
            this.Loaderloading = false
            if(existUser.data && existUser.data.id){
              let peopleData = existUser.data;
              peopleData.email = peopleData.display_email ? peopleData.display_email : peopleData.registered_email
              this.selectedAttendees[count] = peopleData;
            }else{
              const data = this.addItem(entry);
              this.selectedAttendees[count] = data;
            }
            this.attendeeSearch = "";
          } else {
            this.isEmailvalidate = true;
            this.selectedAttendees.pop();
          }
        }
        this.$emit("onSelection", this.selectedAttendees);
      }
      
    },
  },
  computed: {
    ...statesMap(),
    LoaderText() {
      return this.$t("LoaderText");
    },
    peoples() {
      const peopleList = [];
      this.userList.forEach((user) => {
        peopleList.push({
              id: user.id,
              email: user.display_email ? user.display_email : user.registered_email,
              firstName: user.firstName,
              lastName: user.lastName,
              profilePhoto: user.profilePhoto ?? '',
              title: user.title,
              attendedState: null,
              contactEmailIds: user.contactEmailIds,
              is_registered_user: user.is_registered_user,
              is_listed_in_people: user.is_listed_in_people
          });
      })
      return peopleList;
    },
    filteredData() {
      let tempPeoples = this.peoples;
      if (this.attendeeSearch && this.attendeeSearch.trim().length > 0) {
        tempPeoples = tempPeoples.filter((item) => {
          if (
            (item.firstName &&
              item.firstName
                .toLowerCase()
                .indexOf(this.attendeeSearch.toLowerCase()) !== -1) ||
            (item.lastName &&
              item.lastName
                .toLowerCase()
                .indexOf(this.attendeeSearch.toLowerCase()) !== -1) ||
            (item.email &&
              item.email
                .toLowerCase()
                .indexOf(this.attendeeSearch.toLowerCase()) !== -1)
          ) {
            return item;
          }
        });
      }
      return tempPeoples;
    },
    usersWithContactEmails() {
      const userEmails = [];
      this.peoples.forEach((user) => {
        if (user.contactEmailIds && user.contactEmailIds.length > 0) {
          user.contactEmailIds.forEach((email) => {
            if (email) {
              const userData = {
                  id: user.id, 
                  display_email: email, 
                  email: email, 
                  firstName: user.firstName, 
                  lastName: user.lastName, 
                  profilePhoto: user.profilePhoto ?? '',
                  contactEmailIds: user.contactEmailIds, 
                  attendedState: user.attendedState ?? null,
                is_registered_user: user.is_registered_user,
                is_listed_in_people: user.is_listed_in_people
                };
              userEmails.push(userData);
            }
          });
        }
      });
      return [
        ...this.meetingAtteendeelist,
        ...userEmails,
      ];
      //return userEmails;
    },
  },
  methods: {
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
    uniqueKey(){
      return createUUID()
    },
    createUUID,
    addItem(emailId) {
      const newItem = {
        id: createUUID(),
        email: emailId,
        action: 'add'
      };
      return newItem;
    },
    itemSelected(itemEmail){
      const selectedIndex = this.selectedAttendees && this.selectedAttendees.length > 0 ? this.selectedAttendees.findIndex(attendee => attendee.email === itemEmail) : -1
      if(selectedIndex !== -1){
        return true
      }else{
        return false
      }
    },
    itemSelectedGroup(id){
      const selectedIndex = this.selectedAttendees && this.selectedAttendees.length > 0 ? this.selectedAttendees.findIndex(attendee => attendee.id === id) : -1
      if(selectedIndex !== -1){
        return true
      }else{
        return false
      }
    },
    selectEmail(uid, emailId){
      const existId = this.selectedAttendees.findIndex(selected => selected.id == uid && selected.email == emailId)
      if(existId !== -1){
        this.selectedAttendees.splice(existId, 1)
        return;
      }
      const userData = _.cloneDeep(this.userList)
      const result = userData.find(item => item.id == uid);
      const people = {
              id: result.id,
              email: emailId,
              firstName: result.firstName,
              lastName: result.lastName,
              profilePhoto: result.profilePhoto ?? '',
              title: result.title,
              attendedState: null,
              contactEmailIds: result.contactEmailIds
          };
      //this.selectedEmail = people
      this.selectedAttendees.push(people)
      this.attendeeSearch = ''
      this.activeDropDown = false
    },
    searchData(event){
      this.attendeeSearch = event.target.value
    },
    onClickOutside(){
      this.activeDropDown = false
    },
    onCloseConditional (e) {
      if(e.target.id && e.target.id == "searchComboBox"){
        return false;
      }else if(e.target.attributes.for && e.target.attributes.for.value == "searchComboBox"){
        return false
      }else if(e.target && e.target.classList.contains('v-select__slot') && e.target.querySelector('#searchComboBox')){
        return false
      }else if(e.target && e.target.classList.contains('v-select__selections') && e.target.querySelector('#searchComboBox')){
        return false
      }else if(e.target && e.target.classList.contains('selected-chip-box')){
        return false
      }else{
        return true
      }
    },
    deleteAttende(id) {
      const selectedIndex = this.selectedAttendees.findIndex(item => item.id === id)
      if(selectedIndex !== -1){
        this.selectedAttendees.splice(selectedIndex, 1)
      }
      this.addAtteendees();
    },
    addAtteendees() {
      this.$emit("onSelection", this.selectedAttendees);
      this.activeDropDown = false;
    },
    close() {
      this.activeDropDown = false;
    },
    onUpdate(value) {
      if (value) {
        if (value.length === 0) {
          this.selectedAttendees = [];
        }
      }
    },
  },
};

const validateEmail = (email) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};

function statesMap() {
  return mapState({
    userList: (state) => state.people.userList,
  });
}
</script>
<style >
.foot {
  display: block;
  line-height: 70px;
  border-top: 1px solid #e0e0e0;
  text-align: center;
  height: 80px;
  background-color: #f4f4f4 !important;
}
.combo-list .v-list-item {
  cursor: pointer;
}
.combo-list .v-list-item:hover {
  background-color: #e6e6e6 !important;
}
.combo-list .v-list-item.selected {
  background-color: #e6e6e6 !important;
}

.combo-list .v-list-item label {
  cursor: pointer;
}

.user-combo-selection {
  background-color: #f4f4f4 !important;
  position: absolute;
  width: 100%;
  z-index: 9999999;
  top: 0px;
}
.v-list-group.selected .v-list-group__header {
  background-color: #e6e6e6 !important;
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>